import { Box, Button, Flex } from '@modusign/design-system';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { Awaited } from 'ts-essentials';

import icon from '@app/assets/icons/icon-warning.svg';
import useBulkRequestItem from '@app/features/bulkRequest/hooks/useBulkRequestItem';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { modalClose } from '@app/store/modal/actions';
import { postBulkRequestsTerminate } from '@app/store/transport-layer/bulk-request/bulk-requests/terminate';

interface BulkRequestTerminateWarningModalProps {
  bulkRequestId: string;
}

function BulkRequestTerminateWarningModal({
  bulkRequestId,
}: BulkRequestTerminateWarningModalProps) {
  const dispatch = useDispatch();

  const workspaceId = useWorkspaceId();
  const { refetch } = useBulkRequestItem(bulkRequestId);
  const { mutateAsync: terminateBulkRequest, isLoading } = useMutation<
    Awaited<ReturnType<typeof postBulkRequestsTerminate>>,
    AxiosError,
    Parameters<typeof postBulkRequestsTerminate>
  >((vs) => postBulkRequestsTerminate(...vs), {
    onSuccess: () => {
      dispatch(modalClose());
      refetch();
    },
  });

  return (
    <div className="Container Container--max-sm">
      <Flex className="Card Card--pop box-10x align-center" flexDirection="column">
        <Box>
          <img alt="warning" className="space-4x" src={icon} />
          <h3 className="space-4x">
            <strong>대량전송 종료</strong>
          </h3>
          <p className="space-7x">
            종료 시 더 이상 해당 대량전송을 재시작하실 수 없습니다.
            <br />
            데이터 수정 및 추가적인 전송은 새로운 대량전송을 통해 시작해주세요.
            <br />
            아래 버튼을 눌러 대량전송을 종료 하실 수 있습니다.
          </p>
        </Box>
        <Flex gap={2} justifyContent="center">
          <Button onClick={() => dispatch(modalClose())}>닫기</Button>
          <Button
            isLoading={isLoading}
            onClick={() => terminateBulkRequest([workspaceId, bulkRequestId])}
          >
            대량전송 종료
          </Button>
        </Flex>
      </Flex>
    </div>
  );
}

export default BulkRequestTerminateWarningModal;
